import { useAssignSetting } from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/useSetting";
import { HELP_CENTER_VIP_SUPPORT_250422 } from "@faire/web-api--source/indigofair/settings/HELP_CENTER_VIP_SUPPORT_250422";

export const useAssignSettingHelpCenterVipSupport = () =>
  useAssignSetting(HELP_CENTER_VIP_SUPPORT_250422);
